
export default function HomePageContent() {
    return (
      <h2>Home Page</h2>
      
    );
  }
  